import { LoaderContainer, StyledLoader } from './Loader.styles';

import { useAppSelector } from 'store/hooks';

const Loader = () => {
	const { isPunchup } = useAppSelector((state) => state.auth);
	// In punchup/iframe mode the parent frame (PunchupLive) owns all loading UI.
	// Suppressing the tixologi overlay here prevents a double-spinner and the
	// full-page blur from leaking through the iframe while the parent's own
	// white overlay is still covering the iframe.
	if (isPunchup) return null;
	return (
		<LoaderContainer>
			<StyledLoader isPunchup={isPunchup} />
		</LoaderContainer>
	);
};

export { Loader };
